import React, { useState, useContext } from 'react';
import { LanguageContext } from '../../../App';
import { Modal } from '../../ui/Modal';
import { ChevronDownIcon, MapPinIcon, PackageIcon, TruckIcon, CreditCardIcon, ClockIcon } from 'lucide-react';
interface AddOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const AddOrderModal: React.FC<AddOrderModalProps> = ({
  isOpen,
  onClose
}) => {
  const {
    language
  } = useContext(LanguageContext);
  const [isUrgent, setIsUrgent] = useState(true);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    // In a real app, this would send data to an API
    // Close the modal after submission
    onClose();
  };
  return <Modal isOpen={isOpen} onClose={onClose} title={language === 'en' ? 'Add Urgent Order' : 'إضافة طلب عاجل'} size="lg" data-id="element-357">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-358">
        {/* Urgency Toggle */}
        <div className="flex items-center space-x-4 mb-2" data-id="element-359">
          <div className="font-medium text-gray-700" data-id="element-360">
            {language === 'en' ? 'Urgency:' : 'الأولوية:'}
          </div>
          <div className="flex items-center space-x-2" data-id="element-361">
            <button type="button" onClick={() => setIsUrgent(true)} className={`px-3 py-1 text-sm font-medium rounded-md ${isUrgent ? 'bg-red-100 text-red-700 border border-red-300' : 'bg-gray-100 text-gray-700 border border-gray-300'}`} data-id="element-362">
              {language === 'en' ? 'Urgent' : 'عاجل'}
            </button>
            <button type="button" onClick={() => setIsUrgent(false)} className={`px-3 py-1 text-sm font-medium rounded-md ${!isUrgent ? 'bg-congress-blue-100 text-congress-blue-700 border border-congress-blue-300' : 'bg-gray-100 text-gray-700 border border-gray-300'}`} data-id="element-363">
              {language === 'en' ? 'Standard' : 'عادي'}
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-364">
          {/* Customer Selection */}
          <div data-id="element-365">
            <label htmlFor="customer" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-366">
              {language === 'en' ? 'Customer' : 'العميل'}
            </label>
            <div className="relative" data-id="element-367">
              <select id="customer" className="appearance-none block w-full px-4 py-2 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" required data-id="element-368">
                <option value="" data-id="element-369">
                  {language === 'en' ? 'Select a customer' : 'اختر عميل'}
                </option>
                <option value="USR-5623" data-id="element-370">Ahmed Al-Sabah (USR-5623)</option>
                <option value="USR-5622" data-id="element-371">Fatima Al-Qadiri (USR-5622)</option>
                <option value="USR-5621" data-id="element-372">Mohammed Al-Mutairi (USR-5621)</option>
                <option value="USR-5620" data-id="element-373">Sarah Al-Enezi (USR-5620)</option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-3 top-3 text-gray-400" data-id="element-374" />
            </div>
          </div>
          {/* Service Type */}
          <div data-id="element-375">
            <label htmlFor="serviceType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-376">
              {language === 'en' ? 'Service Type' : 'نوع الخدمة'}
            </label>
            <div className="relative" data-id="element-377">
              <select id="serviceType" className="appearance-none block w-full px-10 py-2 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" required data-id="element-378">
                <option value="express" data-id="element-379">
                  {language === 'en' ? 'Express Delivery' : 'توصيل سريع'}
                </option>
                <option value="standard" data-id="element-380">
                  {language === 'en' ? 'Standard Delivery' : 'توصيل قياسي'}
                </option>
                <option value="scheduled" data-id="element-381">
                  {language === 'en' ? 'Scheduled Delivery' : 'توصيل مجدول'}
                </option>
              </select>
              <TruckIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-382" />
              <ChevronDownIcon size={16} className="absolute right-3 top-3 text-gray-400" data-id="element-383" />
            </div>
          </div>
        </div>
        {/* Pickup Location */}
        <div data-id="element-384">
          <label htmlFor="pickupAddress" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-385">
            {language === 'en' ? 'Pickup Address' : 'عنوان الاستلام'}
          </label>
          <div className="relative" data-id="element-386">
            <input type="text" id="pickupAddress" placeholder={language === 'en' ? 'Enter full address' : 'أدخل العنوان الكامل'} className="block w-full px-10 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" required data-id="element-387" />
            <MapPinIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-388" />
          </div>
        </div>
        {/* Delivery Location */}
        <div data-id="element-389">
          <label htmlFor="deliveryAddress" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-390">
            {language === 'en' ? 'Delivery Address' : 'عنوان التوصيل'}
          </label>
          <div className="relative" data-id="element-391">
            <input type="text" id="deliveryAddress" placeholder={language === 'en' ? 'Enter full address' : 'أدخل العنوان الكامل'} className="block w-full px-10 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" required data-id="element-392" />
            <MapPinIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-393" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-394">
          {/* Package Type */}
          <div data-id="element-395">
            <label htmlFor="packageType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-396">
              {language === 'en' ? 'Package Type' : 'نوع الطرد'}
            </label>
            <div className="relative" data-id="element-397">
              <select id="packageType" className="appearance-none block w-full px-10 py-2 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" required data-id="element-398">
                <option value="document" data-id="element-399">
                  {language === 'en' ? 'Document' : 'مستند'}
                </option>
                <option value="small-package" data-id="element-400">
                  {language === 'en' ? 'Small Package' : 'طرد صغير'}
                </option>
                <option value="medium-package" data-id="element-401">
                  {language === 'en' ? 'Medium Package' : 'طرد متوسط'}
                </option>
                <option value="large-package" data-id="element-402">
                  {language === 'en' ? 'Large Package' : 'طرد كبير'}
                </option>
              </select>
              <PackageIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-403" />
              <ChevronDownIcon size={16} className="absolute right-3 top-3 text-gray-400" data-id="element-404" />
            </div>
          </div>
          {/* Delivery Time */}
          <div data-id="element-405">
            <label htmlFor="deliveryTime" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-406">
              {language === 'en' ? 'Required Delivery Time' : 'وقت التوصيل المطلوب'}
            </label>
            <div className="relative" data-id="element-407">
              <input type="datetime-local" id="deliveryTime" className="block w-full px-10 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" required data-id="element-408" />
              <ClockIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-409" />
            </div>
          </div>
        </div>
        {/* Payment Method */}
        <div data-id="element-410">
          <label htmlFor="paymentMethod" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-411">
            {language === 'en' ? 'Payment Method' : 'طريقة الدفع'}
          </label>
          <div className="relative" data-id="element-412">
            <select id="paymentMethod" className="appearance-none block w-full px-10 py-2 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" required data-id="element-413">
              <option value="wallet" data-id="element-414">
                {language === 'en' ? 'Wallet' : 'المحفظة'}
              </option>
              <option value="cash" data-id="element-415">
                {language === 'en' ? 'Cash on Delivery' : 'الدفع عند الاستلام'}
              </option>
              <option value="credit-card" data-id="element-416">
                {language === 'en' ? 'Credit Card' : 'بطاقة ائتمان'}
              </option>
            </select>
            <CreditCardIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-417" />
            <ChevronDownIcon size={16} className="absolute right-3 top-3 text-gray-400" data-id="element-418" />
          </div>
        </div>
        {/* Additional Notes */}
        <div data-id="element-419">
          <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-420">
            {language === 'en' ? 'Additional Notes' : 'ملاحظات إضافية'}
          </label>
          <textarea id="notes" rows={3} className="block w-full px-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-congress-blue-500 focus:border-congress-blue-500" placeholder={language === 'en' ? 'Any special instructions' : 'أي تعليمات خاصة'} data-id="element-421"></textarea>
        </div>
        {/* Action Buttons */}
        <div className="flex justify-end space-x-3" data-id="element-422">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-423">
            {language === 'en' ? 'Cancel' : 'إلغاء'}
          </button>
          <button type="submit" className={`px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white ${isUrgent ? 'bg-red-600 hover:bg-red-700' : 'bg-congress-blue-600 hover:bg-congress-blue-700'}`} data-id="element-424">
            {language === 'en' ? 'Create Order' : 'إنشاء الطلب'}
          </button>
        </div>
      </form>
    </Modal>;
};